// import { CommonHttpOption } from "./../../base/common-http-option";
import { ServiceRoute } from "./../../base/service-route";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
// import { IParentTerm } from "src/app/interfaces/parent-term";
// import { IActivePattern } from "src/app/interfaces/activePattern";
import { HttpHeaders } from "@angular/common/http";
import { CommonHttpOption } from "../../base/common-http-option";

@Injectable({
  providedIn: "root"
})
export class TimesheetService {
  constructor(private coreService: CoreService) { }

  getTimeSheet(query: any, header: HttpHeaders): Observable<any> {
    return this.coreService.post(
      ServiceRoute.timesheet.getTimeSheet,
      query,
      header
    );
  }

  save(command: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.timesheet.save,
      command,
      new CommonHttpOption().headers
    );
  }

}
